// src/components/FooterComponent.jsx

import React from 'react';
import { Container } from 'react-bootstrap';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './css/FooterComponent.css'; // Import your CSS file
import logoBlackWhite from '../assets/img/logo_back_1.png'; // Make sure this path is correct

const FooterComponent = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-main-gray">
      <Container>
        {/* LOGO */}
        <div className="footer-logo-center">
          {/* Logo sirf desktop par dikhega agar link hai to */}
          <Link to="/" className="d-none d-lg-block">
            <img src={logoBlackWhite} alt="BookMyAudition" />
          </Link>
          {/* Mobile ke liye agar logo alag dikhana hai toh yaha add kar sakte ho */}
        </div>

        {/* DESCRIPTION */}
        <p className="footer-desc-center">
          The premier platform connecting talented performers with verified
          casting opportunities worldwide.
        </p>

        {/* ===== DESKTOP VIEW CONTENT ===== */}
        <div className="footer-desktop">
          {/* Quick Links + Support Section (Desktop) */}
          <div className="footer-inline">
            <span className="label">Quick Links -</span>
            <Link to="/about">About Us</Link>
            <span>|</span>
            <Link to="/how-it-works">How It Works</Link>
            <span>|</span>
            <Link to="/roles">Roles</Link>
           {/*  <span>|</span>
            <Link to="/pricing">Pricing</Link> */}

            <span className="space"></span> {/* Spacer */}

            <span className="label">Support -</span>
            <Link to="/faq">FAQ</Link>
            <span>|</span>
            <Link to="/contact">Contact</Link>
            <span>|</span>
            <Link to="/terms">Terms</Link>
            <span>|</span>
            <Link to="/privacy-policy">Privacy</Link>
          </div>

          {/* Social Icons (Desktop and Mobile same styling) */}
          <div className="footer-social-icons">
            <a
              href="https://facebook.com/bookmyaudition"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/Bookmyaudition"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com/bookmyaudition/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              // href="https://youtube.com/"
              href="https://www.youtube.com/@bookmyaudition9709"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>

          {/* Contact Information (Desktop) */}
          <div className="footer-inline">
            <span className="label">Contact -</span>
            <span>support@bookmyaudition.com</span>
            <span>|</span>
            <span>+91 8767 300 200</span>
          </div>
        </div>

        {/* ===== MOBILE VIEW CONTENT ===== */}
        <div className="footer-mobile">
          {/* Social Icons (Mobile) - Same as desktop, but displayed here for mobile view */}
          <div className="footer-social-icons">
            <a
              href="https://facebook.com/bookmyaudition"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com/Bookmyaudition"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://instagram.com/bookmyaudition/"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://youtube.com/"
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>

         

          <div className="footer-top-bar d-block d-md-none mt-2 pb-4">
                <div className="footer-inline md">
                  <span className="label">Quick Links -</span>
                  <Link to="/about">About Us</Link>
                  <span>|</span>
                  <Link to="/how-it-works">How It Works</Link>
                  <span>|</span>
                  <Link to="/roles">Browse</Link>
                </div>

                <div className="footer-inline md">
                  <span className="label">Support -</span>
                  <Link to="/faq">FAQ</Link>
                  <span>|</span>
                  <Link to="/contact">Contact</Link>
                  <span>|</span>
                  <Link to="/terms">Terms</Link>
                  <span>|</span>
                  <Link to="/privacy-policy">Privacy</Link>
                </div>

                <div className="footer-inline d">
                  <span className="label">Contact -</span>
                  <span>support@bookmyaudition.com</span>
                  <span>|</span>
                  <span>+91 8767 300 200</span>
                </div>

              </div>
        </div>

        {/* COPYRIGHT SECTION */}
        <div className="footer-bottom">
          <p>
            © {currentYear} BookMyAudition. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default FooterComponent;